// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"0b67a742","487":"9952bd17","548":"2547648a","608":"17e9c3c5","629":"420f86a2","758":"d2eb0fc9","876":"1caf7f5a","954":"71236a3e","975":"31d6cfe0"}[chunkId] + ".chunk.css";
};